import { ModalProps } from '@mui/material/Modal';
import { Component, ComponentType, FC, MouseEventHandler, RefObject, useEffect, useRef, useState } from 'react';
import { useTimeout } from 'usehooks-ts';

import { useOutsideClick } from '../common/OutsideClick/OutsideClick';
import { CustomModal } from '../components/Modal';

export interface IWithModal {
  open: boolean;
  onClose?: ModalProps['onClose'];
  onClick: MouseEventHandler;
}

export const withModal = <P extends IWithModal = IWithModal>(Component: ComponentType<P>) => {
  return (props: Omit<P, keyof IWithModal>) => {
    //Окно подсказки
    const [open, setOpen] = useState<boolean>(true);
    //Закрыть окно
    const handleClose = () => setOpen(false);

    return <Component {...(props as P)} onClose={handleClose} onClick={handleClose} open={open} />;
  };
};

export const ModalErrorOffline = withModal(CustomModal);
export const ModalErrorOfflineCard = withModal(CustomModal);
export const ModalErrorAddress = withModal(CustomModal);
